import { render, staticRenderFns } from "./WorldOfMusic.vue?vue&type=template&id=1f83035c&scoped=true&"
import script from "./WorldOfMusic.vue?vue&type=script&lang=ts&"
export * from "./WorldOfMusic.vue?vue&type=script&lang=ts&"
import style0 from "./WorldOfMusic.vue?vue&type=style&index=0&id=1f83035c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83035c",
  null
  
)

export default component.exports